const clarifaiApiKey = 'd16ebb66b3bd4faa929048ce85fb4b7e';
export const signUpApi = 'https://face-app-heroku.herokuapp.com/api/v1/auth/signup/'; //http://localhost:5000/api/v1/auth/signup/
export const logInApi = 'https://face-app-heroku.herokuapp.com/api/v1/auth/login/'; //http://localhost:5000/api/v1/auth/login/
export default clarifaiApiKey;